var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchBigIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.706,
    height: 93.706,
    viewBox: "0 0 93.706 93.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "searchBigIcon",
    d: "M-1261.92,180l-29.319-29.319a35.119,35.119,0,0,0,7.429-21.626,35.345,35.345,0,0,0-35.305-35.3,35.344,35.344,0,0,0-35.3,35.3,35.345,35.345,0,0,0,35.3,35.3,35.118,35.118,0,0,0,21.626-7.429l29.319,29.319Zm-83.66-50.945a26.5,26.5,0,0,1,26.466-26.466,26.5,26.5,0,0,1,26.466,26.466,26.5,26.5,0,0,1-26.466,26.466A26.5,26.5,0,0,1-1345.58,129.06Z",
    transform: "translate(1354.919 -93.255)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBigIcon);
export default __webpack_public_path__ + "static/media/searchBigIcon.7117156a624ea0c447dda6084febe4d6.svg";
export { ForwardRef as ReactComponent };